import { useState } from 'react';
import { API_URL } from 'src/environments/environment';
import { DEFAULT_HEADERS } from 'src/shared/constants';
import { useTranslation } from 'react-i18next';
import useAuth from '../useAuth';

type Error = {
  success: boolean;
  message: string;
  errorCode: string;
};

const usePost = () => {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { t } = useTranslation();

  const { getToken } = useAuth();

  const makeRequest = async (
    url: string,
    isSecure: boolean = false,
    body: any = {},
  ) => {
    setLoading(true);
    const headers: any = {};
    if (isSecure) {
      headers.Authorization = `Bearer ${getToken()}`;
    }
    try {
      const response = await fetch(`${API_URL}/${url}`, {
        method: 'POST',
        headers: {
          ...DEFAULT_HEADERS,
          ...headers,
        },
        body: JSON.stringify(body),
      });
      try {
        const json = await response.json();
        setData(json);
        if (json?.success === false || !response.ok) {
          setError(json);
        }
        setLoading(false);
        return json;
      } catch (e) {
        const key: string = 'errors.unknown';
        const resp = {
          success: false,
          message: t(key as any),
          errorCode: 'unknown',
        };
        setError(resp as any);
        return resp;
      }
    } catch (err) {
      setError(err as any);
      setLoading(false);
      return err;
    }
  };

  const invalidateError = () => {
    setError(null);
  };

  return {
    makeRequest,
    invalidateError,
    data,
    error,
    loading,
  };
};

export default usePost;
